import React from "react";
import { inject, observer } from "mobx-react";
import { Grid, Row, Col, Collapse, Button } from "react-bootstrap";
import ListSearch from "../bucket/ListSearch";
import { CombinationItem } from "./CombinationItem";
import { notApplicableItems } from "../../constants/constants-container";
import toastService from "../../services/ToastService";
import { StoreContext } from "../../contexts/StoreContext";

@inject("detailViewStore", "previewStore", "popupStore")
@observer
export class CombinationRepresentation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
    this.items = undefined;
    this.refType = undefined;
  }

  componentDidMount() {
    this.context.setSearchMatrix(this.props.searchMatrixKey, "");
  }

  handleCollapse = () => {
    const { mapped } = this.props;
    if (!mapped) return;
    this.setState({
      open: !this.state.open,
    });
  };

  setItems = async () => {
    const { navigationLookupResult, otherInformation, mapped } = this.props;
    if (mapped !== true) {
      if (
        !navigationLookupResult ||
        !navigationLookupResult.navigationLookupRootItem ||
        !navigationLookupResult.navigationLookupRootItem.items
      )
        return;
      this.items = navigationLookupResult.navigationLookupRootItem.items.filter(
        (item) => item.object.type === "CombinationItem"
      );
    }
    if (mapped === true) {
      if (!otherInformation) return;
      let targetCombinations;
      if (otherInformation.mappedReferenceCombinations) {
        targetCombinations = otherInformation.mappedReferenceCombinations;
      }
      if (otherInformation.mappedNonReferenceCombinations) {
        targetCombinations = otherInformation.mappedNonReferenceCombinations;
      }
      if (
        !targetCombinations ||
        !targetCombinations.length ||
        targetCombinations.length < 1
      )
        return;
      const type = targetCombinations[0].type;
      const tid = targetCombinations[0].tid;
      if (!type || !tid) return;
      await this.context
        .fetchEntityDetailsWithoutCallback(type, tid)
        .then((result) => {
          if (
            !result ||
            !result.item ||
            !result.item.navigationLookupResult ||
            !result.item.navigationLookupResult.navigationLookupRootItem ||
            !result.item.navigationLookupResult.navigationLookupRootItem.items
          )
            return;
          this.items =
            navigationLookupResult.navigationLookupRootItem.items.filter(
              (item) => item.object.type === "CombinationItem"
            );
          this.items = otherInformation.mappedReferenceCombinations
            ? "Reference"
            : "Non-Reference";
        });
    }
  };

  copySqlToClipboard = () => {
    this.hiddenCodeTextArea.select();
    document.execCommand("copy");
    toastService.func_notify(
      "The Combination has been copied to clipboard."
    );
  };
  static contextType = StoreContext;
  render() {
    this.setItems();

    const { searchMatrixKey, mapped } = this.props;
    const { open } = this.state;
    const { fetchingDataStatus } = this.context;
    const fetchingStatus =
      (!mapped && fetchingDataStatus.get("Cubes") === true) ||
      (mapped && fetchingDataStatus.get("Cube") === true);

    if ((!this.items || this.items?.length < 1) && !fetchingStatus) return null;

    const searchExpr = this.context.getSearchMatrix[searchMatrixKey] || "";

    const filteredItems = this.items?.filter((item) => {
      if (!item.items) return false;

      const names = item.items.map((i) =>
        i.object.name ? i.object.name.toLowerCase() : ""
      );
      const codes = item.items.map((i) =>
        i.object.code ? i.object.code.toLowerCase() : ""
      );
      if (searchExpr) {
        return (
          (names.some((name) => name.includes(searchExpr.toLowerCase())) ||
            codes.some((code) => code.includes(searchExpr.toLowerCase()))) &&
          names.every((name) => !notApplicableItems.includes(name))
        );
      } else {
        return names.every((name) => !notApplicableItems.includes(name));
      }
    });

    const combinationItems =
      filteredItems &&
      filteredItems.reduce(function (result, item) {
        const member = item.items.find((x) => x.object.type === "Member");
        if (member) {
          const variable = item.items.find((x) => x.object.type === "Variable");
          variable.object.member = member.object;
          result.push(variable.object);
        }
        return result;
      }, []);

    const combinationItemsClipboard = {
      name: this.props.object.code,
      value: combinationItems,
    };

    return (
      <div className="related-objects custom-panel">
        <div
          className="custom-panel-heading"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex" }}>
            <h4>
              {mapped
                ? `Mapped ${this.refType || ""} Combination Representation`
                : "Combination Representation"}
            </h4>
            {fetchingStatus ? ( // "Cubes" because the PrdLink used for combinationItems is Cube -> check the PrdLink
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            ) : (
              ""
            )}
          </div>
          {mapped ? (
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                this.handleCollapse();
              }}
            >
              {open === true ? "hide" : "show"}
            </a>
          ) : null}
        </div>

        {!fetchingStatus ? ( // "Cubes" because the PrdLink used for combinationItems is Cube -> check the PrdLink
          <Collapse in={mapped === true ? open : true}>
            <div className="custom-panel-body related-types-list">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <ListSearch
                  searchMatrixKey={searchMatrixKey}
                  placeholder={"Filter by Name or Code"}
                />
                <Button
                  bsClass="btn btn-default"
                  style={{ marginBottom: 10 }}
                  onClick={this.copySqlToClipboard}
                >
                  Copy to Clipboard
                </Button>
                <textarea
                  className="hidden-code-textarea"
                  style={{ position: "absolute", left: "-99999px" }}
                  ref={(el) => {
                    this.hiddenCodeTextArea = el;
                  }}
                  value={JSON.stringify(combinationItemsClipboard)}
                  readOnly={true}
                />
              </div>
              <Grid className="cube-structure-item" fluid={true}>
                <Row>
                  <Col xs={6}>
                    <h5>
                      <b>Variable</b>
                    </h5>
                  </Col>
                  <Col xs={6}>
                    <h5>
                      <b>With values restricted to</b>
                    </h5>
                  </Col>
                </Row>
              </Grid>
              <div className="item-list-container large">
                {filteredItems?.length
                  ? filteredItems.map((item, key) => (
                      <CombinationItem item={item} key={key} />
                    ))
                  : "Nothing found"}
              </div>
            </div>
          </Collapse>
        ) : (
          ""
        )}
      </div>
    );
  }
}
